import React, { Children, JSXElementConstructor, ReactElement } from "react";
import { TextField, Checkbox, Button, Input, Stack, styled, Select, Card, Box, Grid, CircularProgress, TableRow, TableHead, TableCell, InputLabel } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import contact from "../css/contact.module.css";
import faq from "../css/faq.module.css";
import base from "../css/base.module.css"
import { red } from "@mui/material/colors";

/*-header-*/

export const LogoCA = styled("div")({
    margin: "-5px 0",
    padding: " 0px 30px  ",
    height: "50px",
    width: "265px",

})

export const LayoutBox = styled("div")({

    fontFamily: "'Noto Sans JP',sans-serif",
    margin: "0px",
    padding: "15px 35px",
    fontWeight: "bold",
    listStyle: "none",

})
export const LinkS = styled("a")({

    padding: "0px 20px",
})
export const LinkW = styled("a")({

    color: "white",
    textDecoration: "none",
})

export const CustomSubmit = styled(Input)({
    backgroundColor: 'red'
});
export const MyPageButton = styled(Button)({
    position: "relative",
    display: "inline-block",
    margin: "-3px 50px 50px",
    padding: "15px 10px",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "280px",
    textAlign: "center",
    transition: "0.3s",

    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }
})
export const MyPageButtonXX = styled(Button)({
    position: "relative",
    display: "inline-block",
    margin: "-3px 50px 50px",
    padding: "15px 10px",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "280px",
    textAlign: "center",
    transition: "0.3s",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }
})
export const MyPageButtonX = styled(Button)({
    position: "relative",
    display: "inline-block",
    margin: "-3px 50px 40px",
    padding: "10px 10px 20px",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "280px",
    //textAlign: "center",
    //transition: "0.3s",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }
})
export const MyPageButtonRed = styled(LoadingButton)({
    position: "relative",
    display: "inline-block",
    margin: "100px 0px 100px 0px",
    padding: "1em 3em",
    borderTop: "1px solid #ccc",
    borderRight: "1px solid #999",
    borderBottom: "1px solid #999",
    borderLeft: "1px solid #ccc;",
    cursor: "pointer",
    backgroundColor: "#cf2525",
    background: "linear-gradient(to right,#cf2525,#eb6101)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#fff",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "280px",
    textAlign: "center",
    transition: "0.3s",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }
})
export const Komozi = styled(Button)({
    position: "relative",
    display: "inline-block",

    fontSize: "12px",
    padding: "0px ",
    color: "#000",
    margin: "0px -287px 10px",

})
export const BackButton = styled(Button)({
    position: "relative",
    display: "inline-block",
    margin: "30px 50px 50px",
    padding: "15px 10px",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "140px",
    textAlign: "center",
    transition: "0.3s",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }
})
export const OnsiteButton = styled(Button)({
    /*position: "relative",
    display: "inline-block",
    margin: "-3px 50px 50px",
    padding: "15px 10px",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "280px",
    textAlign: "center",
    transition: "0.3s",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }*/
    color: "#000",
    fontSize: "22px"
})
export const OnsiteButtonXL = styled(Button)({
    position: "relative",
    display: "inline-block",
    margin: "30px 0px 50px 15px" ,
    padding: "15px 10px",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "280px",
    textAlign: "center",
    transition: "0.3s",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }
})
export const OnsiteLoadButton = styled(LoadingButton)({
    position: "relative",
    display: "inline-block",
    margin: "30px 50px 50px",
    padding: "15px 10px",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "22px",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "280px",
    textAlign: "center",
    transition: "0.3s",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }
})
export const LogOutButton = styled(LoadingButton)({
    position: "relative",
    display: "inline-block",
    margin: "0px 0px 0px 0px",
    padding: "1em ",
    cursor: "pointer",
    backgroundColor: "#FFE664",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    fontSize: "12px",
    fontWeight: "bold",
    letterSpacing: "1.2px",
    color: "#000",
    textDecoration: "none",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    width: "140px",
    textAlign: "center",
    transition: "1.5s",
    "&:hover": {
        background: "linear-gradient(to right,#9b9b9b,#797979,#3c3c3c)",
        color: "#fff",
    }
})
//export const OnsiteButton = styled(Button)({
//    position: "relative",
//    display: "inline-block",
//    margin: "0px 0 100px",
//    borderTop: "1px solid #ccc",
//    borderRight: "1px solid #999",
//    borderBottom: "1px solid #999",
//    borderLeft: "1px solid #ccc;",
//    padding: "1em 3em",
//    //width: "90%",
//    //height: "70%",
//    cursor: "pointer",
//    color: "#333",
//    fontSize: "auto",
//    fontWeight: "bold",
//    background: "linear-gradient(to left, #FFE664,#FCAF17)",
//    borderRadius: "3px",
//    WebkitBorderRadius: "3px",
//    MozBorderRadius: "3px",
//    boxShadow: "5px 5px 3px -3px #aaa",
//    MozBoxShadow: "5px 5px 3px -3px #aaa",
//    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
//    "&:hover": {
//        background: "linear-gradient(to right,#cf2525,#eb6101)",
//        color: "#333",
//    }
//})

export const OnsiteLoadingButton = styled(LoadingButton)({
    /*position: "relative",
    display: "inline-block",
    margin: "0px 0 100px",
    borderTop: "1px solid #ccc",
    borderRight: "1px solid #999",
    borderBottom: "1px solid #999",
    borderLeft: "1px solid #ccc;",
    padding: "1em 3em",
    //width: "90%",
    //height: "70%",
    cursor: "pointer",
    color: "#333",
    fontSize: "auto",
    fontWeight: "bold",
    background: "linear-gradient(to left, #FFE664,#FCAF17)",
    borderRadius: "3px",
    WebkitBorderRadius: "3px",
    MozBorderRadius: "3px",
    boxShadow: "5px 5px 3px -3px #aaa",
    MozBoxShadow: "5px 5px 3px -3px #aaa",
    WebkitBoxShadow: "5px 5px 3px -3px #aaa",
    "&:hover": {
        background: "linear-gradient(to right,#cf2525,#eb6101)",
        color: "#333",
    }*/
    color: "#000",
    fontSize: "22px"

})

export const OnsiteTextLabel = styled(InputLabel)({
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: 1,
    color: "black",
    margin: 0,
    padding: 0,
})

const myStyle = {
    '& .MuiInputBase-input': {
        color: '#000000',    // ���͕����̐F
    },
    '& label': {
        color: '#AAAAAA', // �ʏ펞�̃��x���F 
    },
    '& .MuiInput-underline:before': {
        borderBottomColor: '#CCCCCC', // �ʏ펞�̃{�[�_�[�F
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: '#000000',  // �z�o�[���̃{�[�_�[�F
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#CCCCCC',    // �ʏ펞�̃{�[�_�[�F(�A�E�g���C��)
        },
        '&:hover fieldset': {
            borderColor: '#DDDDDD',    // �z�o�[���̃{�[�_�[�F(�A�E�g���C��)
        },
    },
    '& .width': {

    },
}

export const OnsiteTextField = //styled(TextField)(myStyle);
styled(TextField)({
    width: "calc(100% - 20px);"
})

export const CustomSelect = styled(Select)({
    width: "100%"
})

export const TitleDivBig = styled(Box)({
    fontSize: 20,
    color: "green",
    width: "auto"
})

export const TitleDivSmall = styled(Box)({
    color: "green",
    width: "auto"
})
export const Text01 = styled("div")({
    textAlign: "center",
    margin: "0 0 0 0  ",
    color: "red",
    fontSize: "22px",
    fontWeight: "bold",
    fontFamily: "sans-serif",
})

//�����j���[�̊Ԋu
export const AreaArea = styled(Box)({
    justifyContent: "center",
    alignItems: "center",
    marginTop: "0%",
    marginLeft: "0%",
    marginRight: "0%",

})
export const MainContentsBox = styled(Box)({
    justifyContent: "center",
    alignItems: "center",
    marginTop: "0%",
    maxWidth: "90%",

})
export const MainContentsBoxH = styled(Box)({
    position: "fixed",
    display: "flex",
    backgroundColor: "#00506A",
    width: "100%",
    height: "80px",
    top: "0",
    zIndex: "999",
    justifyContent: "space-between",
})
export const MainContentsBoxL = styled(Box)({
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-4%",
    marginLeft: "30%",
    marginRight: "30%",
})
export const MainContentsBoxS = styled(Box)({
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-5%",
    marginLeft: "15%",
    marginRight: "15%",

})
export const MainContentsBoxF = styled(Box)({
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10%",


})
export const MainContentsBoxM = styled(Box)({
    justifyContent: "center",
    alignItems: "center",
    marginTop: "0%",
    marginLeft: "-20%",
    marginRight: "-20%",
})

export const ForPC = styled("div")({
    display: "block"


})
export const ForSP = styled("div")({
    display: "none",
})
export const MainContentsDiv = styled("div")({
    justifyContent: "center",
    alignItems: "center",
    marginTop: "5%",
    marginLeft: "5%",
    marginRight: "5%",
})

export const CenterBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 0,
    marginBottom: 0,
})

export const MessageBox = styled(Box)({
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    border: "solid",
    backgroundColor: "#ECECEC",
    textAlign: "center"
})

export const SystemTitleBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#ffff00",
    color: "white",
    fontSize: 24,
    fontWeight: "bold"
})

export const SystemTitleText = styled(Box)({
    display: "flex",
    justifyContent: "center",
    color: "white",
    fontSize: 24,
    fontWeight: "bold"
})

export const SystemSubTitleText = styled(Box)({
    display: "flex",
    justifyContent: "center",
    color: "white",
    fontSize: 20,
    fontWeight: "bold"
})

export const SystemUserNameBox = styled(Box)({
    display: "flex",
    color: "white",
    fontWeight: "bold",
})

export const SystemSubTitleBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "end",
    backgroundColor: "#006485",
    paddingTop: 20,
    paddingBottom: 20,
    color: "white",
    fontSize: 20,
    fontWeight: "bold",
})

export const ErrorMessageBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "conter",
    fontcolor: "red",
    color: "red",
    fontSize: 15
})

export const ContentsBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "end",
    paddingTop: 20,
    paddingBottom: 20,
    fontSize: 15,
    border: "solid",
})

export const CenterGrid = styled(Grid)({
    display: "flex",
    justifyContent: "center",
    justifyItems: "center",
    alignItems: "center",
    alignContent: "center"
})

export const PageColumnGrid = (child: React.ReactNode) => {
    return <Grid container spacing={3} alignItems="stretch" justifyContent="center" direction="column">
        {child}
    </Grid>
}

type TitleDivProp = {
    title: string,
    contents: string,
}

export const TitleDiv = (prop: TitleDivProp) => {

    return (

        <section className={faq.faqArea}>
            <div className={faq.faqAreaInner}>
                <div className={faq.faqCategory}>
                    <h3>{prop.title}</h3>
                </div>
            </div>
        </section>
    );
}

export type ErrorMessageCompParam = {
    message: string
}

export const ErrorMessageComp = (prop: ErrorMessageCompParam) => {
    return (
        <div className={base.flexCenterColumn}>
            <div className={base.errorMessage}>
                {prop.message}
            </div>
        </div>
    );
}

type TitleDivParam = {
    title: string,
}


export const Title = (prop: TitleDivProp) => {

}

export const ContentsBox1 = styled(Box)({

    backgroundColor: "#006485",
    height: "255px",
    width: "100%",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
})

type FooterButtonProp = {
    returnButton: JSX.Element,
    submitButton: JSX.Element,
}

export const FooterButtons = (prop: FooterButtonProp) => {
    return (
        <Box>
            {prop.returnButton}
            {prop.submitButton}
        </Box>
    );
}

type GridLabelsProp = {
    label: JSX.Element,
    controller: ReactElement<any, any>//ReactElement<any, string | JSXElementConstructor<any>>,
}

export const GridInputRow = (prop: GridLabelsProp) => {
    return (
        <>
            <CenterGrid direction="row">
                <Grid item xs={2}></Grid>
                <Grid item xs={3}>{prop.label}</Grid>
                <Grid item xs={4}>{prop.controller}</Grid>
                <Grid item xs={3}></Grid>
            </CenterGrid>
        </>
    );
}

export const OnSiteTableHead = styled(TableHead)({
    backgroundColor: "#006485",
    color: "white",
    textAlign: "center",
})
export const OnSiteTableHeadCellL = styled(TableCell)({
    backgroundColor: "#006485",
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
    width: "50%",
    borderTop: "1px solid #ccc",
    borderRight: "1px solid #999",
    borderBottom: "1px solid #999",
    borderLeft: "1px solid #ccc;",

})
export const OnSiteTableHeadCellH = styled(TableCell)({
    backgroundColor: "#00506A",
    /* color: "white",*/
    textAlign: "center",
    fontWeight: "bold",
    /*textDecoration: "none",*/
    width: "10%",

})

export const OnSiteTableHeadCell = styled(TableCell)({
    backgroundColor: "#006485",
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
    width: "20%",
    borderTop: "1px solid #ccc",
    borderRight: "1px solid #999",
    borderBottom: "1px solid #999",
    borderLeft: "1px solid #ccc;",

})

export const OnSiteTableHeadCellW = styled(TableCell)({
    backgroundColor: "#ffffff",
    padding: "0.1em  ",

})

export const OnSiteTableRow = styled(TableHead)({
    backgroundColor: "#ECECEC",
    color: "black",
    textAlign: "center",


})
export const OnSiteTableBodyCellL = styled(TableCell)({
    backgroundColor: "#ECECEC",
    color: "black",
    textAlign: "center",
    width: "50%",
})
export const OnSiteTableBodyDisableCellL = styled(TableCell)({
    backgroundColor: "#999999",
    color: "black",
    textAlign: "center",
    width: "50%",
})
export const OnSiteTableBodyCell = styled(TableCell)({
    backgroundColor: "#ECECEC",
    color: "black",
    textAlign: "center",
    fontWeight: "bold",
    width: "20%",

})
export const OnSiteTableBodyDisableCell = styled(TableCell)({
    backgroundColor: "#999999",
    color: "black",
    textAlign: "center",
    fontWeight: "bold",
    width: "20%",
})

export const OnsiteProgress = styled(CircularProgress)({
    color: "primary",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center"
})
export const OnSiteTableFooter = styled(TableCell)({
    backgroundColor: "#006485",
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
    width: "100vw",
    bottom: "0",


})
export const Gridman = styled(Grid)({
    marginTop: "-70px",
    marginBottom: "100px",
})

